import React from 'react'
import { IProcurementSupplierNextStatus } from '@/main/models/response';
import OrderStatusComponent from '../../status/orderStatusComponent';
import { IdName } from '@/main/models/common';
import { ProcurementStatusEnum } from '@/main/services/enum/StatusProcurement';
import * as S from './styles';

interface IButtonStatusProps {
  procurementSupplierNextStatus: IProcurementSupplierNextStatus;
  guidProcurementSupplier: string;
  guidSupplier: string;
  deliveryBySupplier: boolean;
  handleOpenInfoSide: (
    guidSupplier: string,
    deliveryBySupplier: boolean,
    statusSupplier: number,
    open: boolean,
    guidProcurementSupplier: string,
    guidProcurementStatusCompany: string,
    idProcurementStatusCompany: number
  ) => void;
}
function ButtonStatus({
  procurementSupplierNextStatus,
  guidProcurementSupplier,
  guidSupplier,
  deliveryBySupplier,
  handleOpenInfoSide
}: IButtonStatusProps) {
  const inTransitToReceivedDeliverySupplier = procurementSupplierNextStatus.idProcurementStatus === ProcurementStatusEnum.Delivered && !deliveryBySupplier

  if (inTransitToReceivedDeliverySupplier) return null;
  const mountStatusSupplier: IdName = {
    id: procurementSupplierNextStatus.idProcurementStatus,
    name: procurementSupplierNextStatus.procurementStatus
  }
  return (
    <S.ListButtons key={procurementSupplierNextStatus.guidProcurementStatusCompany}>
      <OrderStatusComponent
        guidSupplier={guidSupplier}
        deliveryBySupplier={deliveryBySupplier}
        status={mountStatusSupplier}
        name={procurementSupplierNextStatus.procurementStatus}
        guidProcurementSupplier={guidProcurementSupplier}
        guidProcurementStatusCompany={procurementSupplierNextStatus.guidProcurementStatusCompany}
        idProcurementStatusCompany={procurementSupplierNextStatus.idProcurementStatusCompany}
        handleOpenInfoSide={handleOpenInfoSide}
      />
    </S.ListButtons>
  )
}

export default ButtonStatus